import React, { Component } from 'react';
import { connect } from 'react-redux'
import { fetchSearchInput, fetchProducts, fetchCarousels, fetchSuggestProducts, fetchPromotionProducts } from '../actions'
import { Row, Col } from 'react-bootstrap'
import CategoryItemlong from './category_itemlong'
class ShowCategory extends Component {

    componentWillMount() {
        this.props.fetchSearchInput('')
        this.props.fetchProducts('')
        this.props.fetchCarousels()
        this.props.fetchSuggestProducts()
        this.props.fetchPromotionProducts()
    }

    render() {
        return (
            <div>
                <Row className="row-categories">
                    <CategoryItemlong history={this.props.history} categoryname='อาหารทะเล' img_url='../../static/images/categories/cat-1.png' />
                    <CategoryItemlong history={this.props.history} categoryname='เนื้อสัตว์' img_url='../../static/images/categories/cat-2.png' />
                    <CategoryItemlong history={this.props.history} categoryname='ผัก' img_url='../../static/images/categories/cat-3.png' />
                    <CategoryItemlong history={this.props.history} categoryname='เครื่องแกง' img_url='../../static/images/categories/cat-4.png' />
                    <CategoryItemlong history={this.props.history} categoryname='ของแห้ง' img_url='../../static/images/categories/cat-5.png' />
                    <CategoryItemlong history={this.props.history} categoryname='ผลไม้' img_url='../../static/images/categories/cat-6.png' />
                </Row>
            </div>
        );
    }
}

export default connect(null, { fetchSearchInput, fetchProducts, fetchCarousels, fetchSuggestProducts, fetchPromotionProducts })(ShowCategory)



// WEBPACK FOOTER //
// ./src/components/showcategory.js